import { useXR, TeleportTarget } from "@react-three/xr";

/* Teleport surface + visible teleport-point markers. Only rendered during an
   active VR session so the floor rings don't clutter the desktop view. */
export default function TeleportFloor({ onTeleport }) {
  const session = useXR((s) => s.session);
  if (!session) return null;

  return (
    <>
      <TeleportTarget onTeleport={onTeleport}>
        <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, -1.9, 0]}>
          <circleGeometry args={[14, 64]} />
          <meshBasicMaterial color="#0a1420" transparent opacity={0.05} />
        </mesh>
      </TeleportTarget>
      {[
        [0, 2.2],
        [-3, -1.5],
        [3, -1.5],
      ].map(([x, z], i) => (
        <mesh key={i} rotation={[-Math.PI / 2, 0, 0]} position={[x, -1.88, z]}>
          <ringGeometry args={[0.45, 0.6, 40]} />
          <meshBasicMaterial color="#00f0ff" transparent opacity={0.28} toneMapped={false} />
        </mesh>
      ))}
    </>
  );
}
